import { h } from 'preact'
import { PureComponent } from 'preact-compat'
import classNames from 'classnames'

interface ContentProps {
  content: string
  className?: string
  isControl?: boolean
}

class Content extends PureComponent<ContentProps> {
  element: HTMLElement | undefined

  componentDidUpdate (): void {
    this.renderSubComponents()
  }

  componentDidMount (): void {
    this.renderSubComponents()
  }

  renderSubComponents (): void {
    if (this.element) {
      window.insided.bindPreactComponents(this.element)
    }
  }

  render ({ content, className, isControl }: ContentProps) {
    return (
      <div
        data-helper='gallery'
        data-data='{"delegate": "img:not([src*=\"emojione\"]), a.fancybox img", "type": "image"}'
        ref={element => { this.element = element }}
        className={classNames(
          'post__content',
          'post__content--new-editor',
          className,
          isControl && 'post__content--control'
        )}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    )
  }
}

export default Content
